import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import {
  fetchManagerStats,
  fetchManagerSubmissions,
  type ManagerSubmissionsFilters,
} from '@/api/managerSubmissions'

export function useManagerStats() {
  return useQuery({
    queryKey: queryKeys.manager.stats,
    queryFn: fetchManagerStats,
    refetchInterval: 30000,
  })
}

export function useManagerSubmissions(filters: ManagerSubmissionsFilters = {}) {
  return useQuery({
    queryKey: queryKeys.manager.list(
      filters as unknown as Record<string, unknown>
    ),
    queryFn: () => fetchManagerSubmissions(filters),
    refetchInterval: 30000,
  })
}
